export default "__VITE_ASSET__DNFgpV5h__"